module.exports = __webpack_public_path__ + "static/media/img86.796f92fb.jpg";